<template>
  <div class="main">
    <global-tag>
      <span slot="title">居家养老管理</span>
      <div class="search" slot="search">
        <el-form label-width="160px" :model="queryInfo">
          <div class="searchBox">
            <div class="content">
              <el-row>
                <el-col :span="5">
                  <el-form-item label="机构养老点名称：">
                    <el-input
                      clearable
                      v-model.trim="queryInfo.organizationName"
                      style="width: 100%"
                      placeholder="请输入机构养老点名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="服务类型：">
                    <el-select
                      style="width: 100%"
                      v-model="queryInfo.serviceStationType"
                      placeholder="服务类型"
                    >
                      <el-option
                        v-for="item in serveOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item label="负责人：">
                    <el-input
                      clearable
                      v-model.trim="queryInfo.principal"
                      style="width: 100%"
                      placeholder="请输入负责人"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="btn">
              <el-button type="primary" @click="querySearch" class="searchBtns"
                >查询</el-button
              >
            </div>
          </div>
        </el-form>
      </div>
    </global-tag>
    <div class="table_title">
      <div class="btn_group">
        <el-button
          type="success"
          class="button openBtns"
          size="medium"
          @click="addServices('新增', 'add')"
          >新增</el-button
        >
      </div>
      <!-- 筛选按钮 -->
      <div class="screen_container">
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            class="dropRests"
            @click="reset"
          ></el-button>
          <!-- <el-button type="primary" style="padding: 10px 20px"> -->
          <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
            <span class="el-dropdown-link">
              <i class="el-icon-s-grid el-icon--right" style="color: #fff"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="table_checkbox">
              <el-dropdown-item>
                <el-checkbox-group
                  v-model="tableChekbox"
                  @change="tableChekboxChange"
                >
                  <el-checkbox label="序号"></el-checkbox><br />
                  <el-checkbox label="机构名称"></el-checkbox><br />
                  <el-checkbox label="站点类型"></el-checkbox><br />

                  <el-checkbox label="机构负责人"></el-checkbox><br />

                  <el-checkbox label="联系电话"></el-checkbox><br />

                  <el-checkbox label="机构等级"></el-checkbox><br />
                  <el-checkbox label="简介"></el-checkbox><br />
                  <el-checkbox label="地址"></el-checkbox><br />
                  <el-checkbox label="操作"></el-checkbox><br />
                </el-checkbox-group>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- </el-button> -->
        </el-button-group>
      </div>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        :header-cell-style="{
          background: '#e6e6e6',
          color: '#000',
        }"
        border
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '序号') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="机构名称"
          align="center"
          prop="organizationName"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构名称') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          label="站点类型"
          align="center"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '站点类型') != -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.serviceStationType == 1">服务中心</span>
            <span v-if="scope.row.serviceStationType == 2">机构</span>
          </template>
        </el-table-column>
        <el-table-column
          label="机构负责人"
          align="center"
          prop="principal"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构负责人') !=
            -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="联系电话"
          align="center"
          prop="telphone"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '联系电话') != -1
          "
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="机构等级"
          align="center"
          v-if="
            this.tempTableChekbox.findIndex((item) => item == '机构等级') != -1
          "
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.organizationLeval == 1">A</span>
            <span v-if="scope.row.organizationLeval == 2">AA</span>
            <span v-if="scope.row.organizationLeval == 3">AAA</span>
          </template>
        </el-table-column>
        <el-table-column
          label="简介"
          align="center"
          v-if="this.tempTableChekbox.findIndex((item) => item == '简介') != -1"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.introduction"></div>
          </template>
        </el-table-column>

        <el-table-column
          label="地址"
          align="center"
          prop="address"
          v-if="this.tempTableChekbox.findIndex((item) => item == '地址') != -1"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
          v-if="this.tempTableChekbox.findIndex((item) => item == '操作') != -1"
        >
          <template slot-scope="scope">
            <span @click="addServices('详情', scope.row)" class="operBtn"
              >查看</span
            >
            <span @click="addServices('编辑', scope.row)" class="operBtn"
              >编辑</span
            >

            <span @click="deleteItem(scope.row)" class="operBtn">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_container">
      <el-pagination
        :page-size="pageOne.pageSize"
        :current-page.sync="pageOne.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOne.total"
        @size-change="handletableDataSize"
        @current-change="handleTableDataChange"
      ></el-pagination>
    </div>
    <add-service
      v-if="serviceState"
      :openData="serviceInfo"
      @cancleService="cancleService"
    ></add-service>
  </div>
</template>
<script>
import globalTag from "../../components/globalTag"
import addService from "./components/addService"

export default {
  name: "serviceMange",
  inject: ["reload"], //注入
  components: { globalTag, addService },
  data() {
    return {
      serveOptions: [
        { value: "1", label: "服务中心" },
        { value: "2", label: "机构" },
      ],
      pageOne: { total: 0, pageSize: 10, pageNo: 1 },
      tableData: [],
      queryInfo: {
        organizationName: "",
        serviceStationType: "",
        principal: "",
      },
      serviceState: false,
      serviceInfo: {},

      tempTableChekbox: [
        "序号",
        "机构名称",
        "站点类型",
        "机构负责人",
        "联系电话",
        "机构等级",
        "简介",
        "地址",
        "操作",
      ],
      tableChekbox: [
        "序号",
        "机构名称",
        "站点类型",
        "机构负责人",
        "联系电话",
        "机构等级",
        "简介",
        "地址",
        "操作",
      ],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 当前页
    handleTableDataChange(val) {
      this.pageOne.pageNo = val
      this.getList()
    },
    // 分页大小
    handletableDataSize(val) {
      this.pageOne.pageSize = val
      this.getList()
    },
    // 获取数据
    getList() {
      let params = {
        pageNo: this.pageOne.pageNo,
        pageSize: this.pageOne.pageSize,
        organizationName: this.queryInfo.organizationName,
        serviceStationType: this.queryInfo.serviceStationType,
        principal: this.queryInfo.principal,
      }
      this.$http
        .request({
          url: "/ypt/admin/homeCare/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.pageOne.total = 0
              return
            }
            if (res.content.list.length > 0) {
              res.content.list.forEach((item) => {
                item.hasChagned = Number(item.counts) - Number(item.stock)
              })
            }
            this.tableData = res.content.list
            this.pageOne.total = res.content.count
          }
        })
    },
    //删除表格信息
    deleteItem(date) {
      let params = {
        id: date.id,
      }
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .request({
            url: "/ypt/admin/homeCare/info/deleteById",
            method: "POST",
            data: params,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              // this.tableData = [];
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    // 选择列的展示方式
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    // 取消新增、编辑、查看
    cancleService(state) {
      this.serviceState = false

      if (state == true) {
        this.getList()
      }
    },

    // 新增\编辑\查看
    addServices(title, row) {
      this.serviceState = true

      this.serviceInfo = {}
      this.serviceInfo = {
        title: title,
        id: title == "新增" ? "" : row.id,
        state: true,
      }
    },

    // 页面刷新
    reset() {
      this.reload()
    },
    // 搜索
    querySearch() {
      this.getList()
    },
  },
}
</script>
<style lang="less" scoped>
.searchBox {
  display: flex;
  .content {
    flex: 1;
  }
}
/deep/.table_title {
  margin-top: 15px !important;
}
/deep/.btn_group {
  margin-top: 0px !important;
}
.button {
  margin-bottom: 4px;
}
.labelImportBtn {
  background: orange;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 10px;
  font-size: 12px;
  padding: 0 17px;
  color: #fff;
  line-height: 28px;
  display: inline-block;
}
.operBtn {
  cursor: pointer;
  margin-left: 10px;
}
</style>
